import React, { useState, useEffect } from 'react';
import { Input } from 'tea-component';

interface IInputNumberComponentProps {
  initialData: number | null;
  onChange: (value: string) => void;
}

const InputNumberComponent: React.FC<IInputNumberComponentProps> = ({ initialData, onChange }) => {
  // Show "NA" for null values, "0" for zero, or the actual number
  const [value, setValue] = useState(
    initialData === null ? 'NA' : (initialData === 0 ? '0' : String(initialData))
  );
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [isFirstLoad]);

  // Update internal state when initialData changes (e.g., from auto-save restore)
  useEffect(() => {
    const newValue = initialData === null ? 'NA' : (initialData === 0 ? '0' : String(initialData));
    setValue(newValue);
  }, [initialData]);
  
  const handleChange = (newValue: string) => {
    // 只更新本地状态，不触发onChange（实时更新）
    setValue(newValue);
  };

  const handleBlur = () => {
    // 失去焦点时才触发onChange，重新计算汇总
    // 不修改用户输入的显示，让用户看到他们输入的内容
    // 转换逻辑由 pageConfig.tsx 的 onChange 处理
    if (!isFirstLoad) {
      onChange(value);
    }
  };

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleMouseDown = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <Input
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      style={{ textAlign: 'left', width: '100%' }}
    />
  );
};

export default InputNumberComponent;

